import type { Currency } from '@ps/web-core-enums';
import type { PokerSpinAndGo } from '@ps/web-martech-cms-types';

import type { WatchGameVariant } from '../model/types';

export interface WatchGames {
  hallOfFame: HallOfFameList;
  recentBigWins: RecentBigWinsList;
  bestLiveNow: BestLiveNowList;
}

export interface FeaturedTournament {
  tournId: number;
  tournEndTime: number;
  winner: string;
  winAmount: number;
  imageId: number;
  buyIn: number;
  prizePool: number;
  handIds: number[];
  currency: Currency;
  scalePM: number;
  game: number;
  structure: number;
  brandMask: number;
  siteMask: string;
  visibilityCriteria: string;
  excludeCountries: boolean;
  countryStateFilter: CountryStateFilter[] | [];
  flash: boolean;
  sagMax: boolean;
  hiLo: boolean;
  gameVariant: WatchGameVariant;
  entrants?: number;
}

export interface LiveTournament {
  tournId: number;
  buyIn: number;
  prizePool: number;
  game: number;
  sagVariant: number;
  tournAddress: string;
  tournObject: string;
  tableAddress: string;
  tableObject: string;
  firstPlacePrize: number;
  currency: Currency;
  scalePM: number;
  structure: number;
  brandMask: number;
  siteMask: string;
  visibilityCriteria: string;
  excludeCountries: boolean;
  countryStateFilter: CountryStateFilter[];
  flash: boolean;
  sagMax: boolean;
  hiLo: boolean;
  gameVariant: WatchGameVariant;
  entrants?: number;
}

export interface RecentBigWinsList {
  recentBigWinsList?: FeaturedTournament[];
}

export interface HallOfFameList {
  hallOfFameList?: FeaturedTournament[];
}

export interface BestLiveNowList {
  bestLiveNowByPrize?: LiveTournament[];
  bestLiveNowByMultiplier?: LiveTournament[];
}

interface CountryStateFilter {
  country?: string;
  stateInversion?: boolean;
  states?: string[];
}

export interface WatchGamesResponse {
  data: WatchGames;
}

export interface WatchGamesUpdatePayload {
  watchGames: WatchGames;
  availableTabs?: PokerSpinAndGo['watchgames_filter_variables']['tabs'];
}

export enum WatchGamesTabs {
  liveNow = 'liveNow',
  hallOfFame = 'hallOfFame',
  recentBigWins = 'recentBigWins'
}

export type WatchGamesTabsTypes = keyof typeof WatchGamesTabs;
